/**
 * Desktop product pages: the header is transparent over the first product image (see "Header--pdpOverlay" in style.css).
 *
 * - The header turns solid once the page is scrolled.
 * - Each header link / the logo is checked against the part of the first image behind it: over dark areas it switches to
 *   white (and the logo to the "transparent header" logo), over light areas it keeps the regular dark colors. Links in the
 *   same part of the header (left menu, logo, right links) follow the majority so they always match each other.
 */
(function () {
  var header = document.querySelector('.Header--pdpOverlay');
  if (!header) return;

  var desktopQuery = window.matchMedia('(min-width: 1008px)');
  var targetSelector = '.Header__LogoLink, .HorizontalList__Item > .Heading, .HorizontalList__Item > .SelectButton, .Header__Icon';
  var scrollFrame = null;
  var context = null;
  var canvas = null;
  var slideBox = null;
  var loading = false;

  function updateSolid() {
    scrollFrame = null;
    header.classList.toggle('is-pdp-solid', window.pageYOffset > 10);
  }

  window.addEventListener('scroll', function () {
    if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateSolid);
  }, { passive: true });

  updateSolid();

  function toLinear(channel) {
    channel /= 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }

  // Average relative luminance (WCAG) of a region of the sampled image
  function regionLuminance(x, y, width, height) {
    var data;

    try {
      data = context.getImageData(x, y, width, height).data;
    } catch (error) {
      return null;
    }

    var total = 0;
    var count = 0;

    for (var i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 10) continue;
      total += 0.2126 * toLinear(data[i]) + 0.7152 * toLinear(data[i + 1]) + 0.0722 * toLinear(data[i + 2]);
      count++;
    }

    return count ? total / count : null;
  }

  function updateColors() {
    if (!context || !slideBox) return;

    var box = slideBox.getBoundingClientRect();

    // Positions as they are when the page is at the top (the header is sticky, the image scrolls)
    var imageTop = box.top + window.pageYOffset;
    var scale = canvas.width / box.width;

    var groups = [];

    Array.prototype.forEach.call(header.querySelectorAll(targetSelector), function (element) {
      var rect = element.getBoundingClientRect();
      var useLight = false;
      var luminance = null;

      if (rect.width && rect.height) {
        var centerX = rect.left + rect.width / 2;
        var left = Math.max(rect.left - 4, box.left);
        var right = Math.min(rect.right + 4, box.right);
        var top = Math.max(rect.top - 4, imageTop);
        var bottom = Math.min(rect.bottom + 4, imageTop + box.height);

        if (centerX >= box.left && centerX <= box.right && right > left && bottom > top) {
          luminance = regionLuminance(
            Math.floor((left - box.left) * scale),
            Math.floor((top - imageTop) * scale),
            Math.max(1, Math.round((right - left) * scale)),
            Math.max(1, Math.round((bottom - top) * scale))
          );

          // Pick whichever of white / dark text gives the higher contrast
          useLight = luminance !== null && luminance < 0.179;
        }
      }

      var container = element.closest('.Header__FlexItem') || header;
      var group = null;

      for (var i = 0; i < groups.length; i++) {
        if (groups[i].container === container) group = groups[i];
      }

      if (!group) {
        group = { container: container, items: [] };
        groups.push(group);
      }

      group.items.push({ element: element, light: useLight, luminance: luminance, sampled: luminance !== null });
    });

    // Links over the image in the same part of the header (left menu, logo, right links) share one color, picked by majority
    // so a single link over a bright spot doesn't flip on its own (ties use the group's average). Links off the image stay dark.
    groups.forEach(function (group) {
      var sampled = group.items.filter(function (item) { return item.sampled; });
      var light = sampled.filter(function (item) { return item.light; }).length;
      var average = sampled.reduce(function (sum, item) { return sum + item.luminance; }, 0) / (sampled.length || 1);
      var useLight = light * 2 === sampled.length ? sampled.length > 0 && average < 0.179 : light * 2 > sampled.length;

      group.items.forEach(function (item) {
        item.element.classList.toggle('is-pdp-light', item.sampled && useLight);
      });
    });
  }

  function loadSample() {
    if (context || loading || !desktopQuery.matches) return;

    var slide = document.querySelector('.Product__Gallery .Product__SlideItem');
    if (!slide || slide.getAttribute('data-media-type') !== 'image') return;

    var image = slide.querySelector('img');
    if (!image) return;

    // Lazysizes removes data-src once the image has loaded, so fall back to the original image (resized by the CDN)
    var source = image.getAttribute('data-src');
    var original = image.getAttribute('data-original-src');

    if (source) {
      source = source.replace('{width}', '400');
    } else if (original) {
      source = original + (original.indexOf('?') === -1 ? '?' : '&') + 'width=400';
    } else {
      return;
    }

    if (source.indexOf('//') === 0) source = window.location.protocol + source;

    var sample = new Image();
    loading = true;
    sample.crossOrigin = 'anonymous';

    sample.onload = function () {
      canvas = document.createElement('canvas');
      canvas.width = sample.naturalWidth;
      canvas.height = sample.naturalHeight;
      context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(sample, 0, 0);
      slideBox = slide.querySelector('.AspectRatio') || slide;
      updateColors();
    };

    sample.onerror = function () {
      loading = false;
    };

    sample.src = source;
  }

  var resizeTimer = null;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      loadSample();
      updateColors();
    }, 150);
  });

  // Fonts loading can move the links around
  window.addEventListener('load', updateColors);

  loadSample();
})();
